import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { useNavigate, createSearchParams, useLocation } from 'react-router-dom';
import classnames from 'classnames';
import _ from 'lodash';
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Label,
  FormGroup,
  Form,
  Input,
  Table,
  Row,
  Col,
  Spinner,
  UncontrolledTooltip,
  TabPane,
  CardFooter,
} from 'reactstrap';
import PageTabs from 'components/PageTabs';
import { AutoColumns } from 'components/Columns';
import { FixedCenterLoader } from 'components/Loaders';
import TightChart from 'components/TightChart';
import LineChart from 'components/LineChart';
import TimePeriod, { formatDates } from 'components/TimePeriod';
import ReactDatetime from 'react-datetime';
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { listProducts, getDiscovery, toolboxCorrelation, getQuickViewData } from 'services/analysis';
import { optionizeValue, optionizeAll, getValue, getDate, getYearMonth, monthDiff } from 'helpers/select';
import { confidenceLevelToInterval, tablePresets, toPercTable, formatCurrency } from 'helpers/formatter';
import TightTable from 'components/TightTable';
import { colors } from 'helpers/chart';
import { Descriptions, Notes } from '../others';

function ShortTermReturns({ database, product, converter, setName }) {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const fetchData = async () => {
    setLoading(true);

    const [data, err] = await getQuickViewData({
      database,
      product,
      converter,
      page_choice: 'short_term_returns',
    });

    if (data) {
      setResult(data);
      setName(data.formal_name);
    }

    setLoading(false);
  };

  useEffect(() => {
    if (!database || !product) return;

    fetchData();
  }, [database, product, converter]);

  if (loading) {
    return <FixedCenterLoader />;
  }

  if (!result) {
    return null;
  }

  console.log('ShortTermReturns', result);

  return (
    <>
      <Descriptions content={result.descriptions} />
      <Card>
        <CardHeader tag="h4" className="mt-0 text-center">
          <div>{product}</div>
          <div className="tw-text-lg">Currency: {result.currency}</div>
          <div className="tw-text-lg">As of: {result.as_of_date}</div>
        </CardHeader>
        <CardBody>
          <TightTable
            data={result.short_term_returns}
            indexWidth="200px"
            suffix="quickview-short-term-returns"
            dataType="percentage"
            hideIndexTable
          />
        </CardBody>
      </Card>

      <div className="tw-mx-auto tw-max-w-xl">
        <Card>
          <CardHeader tag="h4" className="mt-0 text-center">
            {product}
          </CardHeader>
          <CardBody>
            <TightChart title={product} data={result.short_term_returns} base="cols" dataType="percentage" />
          </CardBody>
        </Card>
      </div>
      <Notes content={result.notes} />
    </>
  );
}

export default ShortTermReturns;
